/* eslint-disable @typescript-eslint/naming-convention */
export enum PaymentProps {
    TYPE_FULL_AMOUNT_DUE = 1,
    TYPE_OTHER_AMOUNT = 2,
    TYPE_MIN_AMOUNT_DUE = 3
}
